function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["title", "node"],
  _excluded2 = ["onCancel", "onOk", "title", "width", "node", "footer"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useDrawerMethod, useMount } from '@micun/form';
import { jsx as _jsx } from "react/jsx-runtime";
export var useBaseDetailDrawer = function useBaseDetailDrawer() {
  var mount = useMount();
  return function (_ref) {
    var title = _ref.title,
      node = _ref.node,
      rest = _objectWithoutProperties(_ref, _excluded);
    return new Promise(function (resolve, reject) {
      mount( /*#__PURE__*/_jsx(DetailDrawer, _objectSpread(_objectSpread({}, rest), {}, {
        node: node,
        title: title,
        onOk: resolve,
        onCancel: reject
      })));
    });
  };
};
var DetailDrawer = function DetailDrawer(params) {
  var _onCancel = params.onCancel,
    _onOk = params.onOk,
    title = params.title,
    width = params.width,
    Detail = params.node,
    footer = params.footer,
    rest = _objectWithoutProperties(params, _excluded2);
  var _useDrawerMethod = useDrawerMethod(),
    render = _useDrawerMethod.render,
    setOpen = _useDrawerMethod.setOpen;
  return render({
    onClose: function onClose() {
      setOpen(false);
      _onCancel();
    },
    footer: footer,
    title: title,
    width: width || 600,
    className: 'supply-drawer',
    children: /*#__PURE__*/_jsx(Detail, _objectSpread(_objectSpread({}, rest), {}, {
      setOpen: setOpen,
      onOk: function onOk(data) {
        _onOk(data);
        setOpen(false);
      },
      onCancel: function onCancel() {
        setOpen(false);
        _onCancel();
      }
    }))
  });
};